import React, { Component } from 'react';
import AppUtils from '../../apputils';
import { GetCategoryData } from '../../models/category';
import { AllUpcomingEvents, FilterEvent } from '../../models/events';
import { GetOrganizersList } from '../../models/users';
import { PnkConnect } from '../../pnk-react/pnk-miniredux';
import UpcomingEventsPage from './upcoming-events';
import $ from 'jquery';



class upcomingEvents extends Component {
    constructor() {
        super()
        this.state = {
            getupcomingEvents: true,
            upcomingEventsList: [],
            filterUpcomingEventsList:[],
            categorylist:[],
            organizerlist: [],
            txtFilterStartDate:'',
            txtFilterEndDate:'',
            ddlFilterLanguage:'',
            ddlFilterCategory:'',
            ddlFilterOrganizer:'',
            txtFilterDateName:'',
            arrowDirection:'up',
            FilterValidation:'',
            getCategory: true,
            getOrganizers: true,
            getFilterEvent:false
        }

        this.filter = {


        }
    }

    HandleRouting = (route) => {

            AppUtils.HandlePageClick(this.props.componentprops, 'session-details/'+ route)
    }

    OpenFilter = ()=>{
        // this.setState({
        //     arrowDirection:'up'
        // })
        var elem = document.getElementById('arrow')
        if(elem.classList.contains('fa-angle-down')){
           // alert('kkk')
            $('#arrow').removeClass('fa-angle-down').addClass('fa-angle-up');
           
        }
        else
        {
         //   alert('lll')
         $('#arrow').removeClass('fa-angle-up').addClass('fa-angle-down');
        }

    
 $('#collapseExample').toggle();
    }


    HandleEventInput = (e) => {
        // alert('hiii')
        const val = e.target.value;
        const name = e.target.name;
        this.setState({ [name]: val });
       

        if (name === 'txtFilterStartDate') {
           // alert('kkk')
            this.setState({
                txtFilterDateName:'txtFilterStartDate'
            })
            this.HandleDateTime();
        }
        else if(name === 'txtFilterEndDate'){
            this.setState({
                txtFilterDateName:'txtFilterEndDate'
            })
            this.HandleDateTime();
        }

    }

   

    HandleDateTime = () => {
     //    alert( new Date().getFullYear() - 55)
        let finaldatetime = '';
    
        let config = {
          // day: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          // shortDay: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
          // MDW: 'D, MM-d',
          // YM: 'yyyy-M',
          OK: 'OK',
          CANCEL: 'CANCEL',
          CLEAR: 'CLEAR'
        }
        var DateTimePicker = require('date-time-picker')
        let that = this;
    
    
     //   let minAge = new Date()
        
        // var year = minAge.getFullYear()
        // var month = minAge.getMonth()
        // var date = minAge.getDate()

        // let minTime = year+'-'+month+'-'+date;
        // alert(month)
        
     //   alert(minAge.toDateString() )
    
        let options = {
          lang: 'EN', // default 'EN'. One of 'EN', 'zh-CN'
          format: 'yyyy-MM-dd', // default 'yyyy-MM-dd'
          // default: '2016-10-19', // default `new Date()`. If `default` type is string, then it will be parsed to `Date` instance by `format` . Or it can be a `Date` instance
        // min: minTime, // min date value, `{String | Date}`, default `new Date(1900, 0, 1, 0, 0, 0, 0)`
         // max: maxAge // max date value, `{String | Date}`, default `new Date(2100, 11, 31, 23, 59, 59, 999)`
        }
    
        var datePicker = new DateTimePicker.Date(options, config)
        datePicker.on('selected', function (formatDate, now) {
          // alert('hii'+formatDate)
          // formatData = 2016-10-19
          // now = Date instance -> Wed Oct 19 2016 20:28:12 GMT+0800 (CST)
          finaldatetime = formatDate;
          if(that.state.txtFilterDateName === 'txtFilterStartDate'){
          that.setState({
            txtFilterStartDate: finaldatetime
          })
        }
        else if(that.state.txtFilterDateName === 'txtFilterEndDate'){
            that.setState({
                txtFilterEndDate: finaldatetime
              })
        }
        })
        datePicker.on('cleared', function () {
          // clicked clear btn
          finaldatetime = finaldatetime;
          if(that.state.txtFilterDateName === 'txtFilterStartDate'){
            that.setState({
              txtFilterStartDate: finaldatetime
            })
          }
          else if(that.state.txtFilterDateName === 'txtFilterEndDate'){
              that.setState({
                  txtFilterEndDate: finaldatetime
                })
          }
        })
      }
    
      ResetData = ()=>{
          this.setState({
            txtFilterStartDate:'',
            txtFilterEndDate:'',
            ddlFilterLanguage:'',
            ddlFilterCategory:'',
            ddlFilterOrganizer:'',
            getFilterEvent:false
          })
      }

    FilterData = (sessionDate)=>{


        // this.setState({
        //     ddlFilterLanguage:e.ddlFilterLanguage,
        //     ddlFilterCategory:e.ddlFilterCategory,
        //     ddlFilterOrganizer:e.ddlFilterOrganizer
        // })

        // alert(this.state.ddlFilterLanguage)
        // let filter = [];
        // for(var i = 0 ; i<this.state.upcomingEventsList.length; i++){
        //     if(this.state.upcomingEventsList[i].event_language == this.state.ddlFilterLanguage){
        //         //alert('jjj')
        //         filter.push(this.state.upcomingEventsList[i])
        //     }
        // }

        // this.setState({
        //     upcomingEventsList:filter
        // })

        this.filter = {
            txtFilterStartDate:sessionDate
            // txtFilterEndDate:this.state.txtFilterEndDate,
            // ddlFilterCategory:this.state.ddlFilterCategory,
            // ddlFilterLanguage:this.state.ddlFilterLanguage,
            // ddlFilterOrganizer:this.state.ddlFilterOrganizer
        }

if(this.filter.txtFilterStartDate !== '' || this.filter.txtFilterEndDate !=='' || (this.filter.ddlFilterCategory !==''&& this.filter.ddlFilterCategory !== undefined)
   || (this.filter.ddlFilterLanguage !==''&& this.filter.ddlFilterLanguage !== undefined) || (this.filter.ddlFilterOrganizer !==''&& this.filter.ddlFilterOrganizer !== undefined)){
        this.setState({
            getFilterEvent:true,
            FilterValidation:''
        })
        //alert(this.filter.txtFilterStartDate + this.filter.txtFilterEndDate + this.filter.ddlFilterCategory + this.filter.ddlFilterLanguage + this.filter.ddlFilterOrganizer)

        console.log(this.filter);
    }
    else{
        this.setState({
         FilterValidation:'Please Choose one...' 
        })
    }


    }

    HandleGetCategoryListSuccessResponse = (res) => {
        if (res !== false) {
      //      console.log('cat' + JSON.stringify(res.data))
            this.setState({
                categorylist: res.data.categorieslist.rows,
                getCategory: false

            })


        }

        else {
            this.setState({
                getCategory: false
            })

        }
    }

    HandleGetOrganizersListSuccessResponse = (res) => {
        if (res !== false) {
          //  console.log(JSON.stringify(res.data.organizerslist.rows))
            this.setState({
                organizerlist: res.data.organizerslist.rows,
                getOrganizers: false

            })


        }

        else {
            this.setState({
                getOrganizers: false
            })

        }
    }

   

    HandleAllUpcomingEventsListSuccessResponse = (res) => {
        if (res !== false) {
      //      console.log(JSON.stringify(res))

      if(this.state.getFilterEvent === true && res.data.eventslist.rows.length>0){
        $('#arrow').removeClass('fa-angle-up').addClass('fa-angle-down');
                $('#collapseExample').toggle();

                this.setState({
                    txtFilterStartDate:'',
                    txtFilterEndDate:'',
                    ddlFilterLanguage:'',
                    ddlFilterCategory:'',
                    ddlFilterOrganizer:'',
                   // arrowDirection:'down'
                })
      }

            this.setState({
                getupcomingEvents: false,
              
               getFilterEvent:false,
               upcomingEventsList:res.data.eventslist.rows
            })
        }

        else {
            
            this.setState({
                // txtFilterStartDate:'',
                // txtFilterEndDate:'',
                // ddlFilterLanguage:'',
                // ddlFilterCategory:'',
                // ddlFilterOrganizer:'',
                getupcomingEvents: false,
                getFilterEvent:false,
                FilterValidation:'No Data',

                upcomingEventsList:[]
            })
        }

        this.setState({
            getupcomingEvents: false
        })

    }

    render() {
        return (
            <div>
                <UpcomingEventsPage {...this.props} upcomingEventsList={this.state.upcomingEventsList}
                HandleRouting={this.HandleRouting} categorylist={this.state.categorylist}
                HandleEventInput = {this.HandleEventInput}
                FilterData={this.FilterData}
                ResetData = {this.ResetData}
                organizerlist={this.state.organizerlist} mystate={this.state}
                OpenFilter={this.OpenFilter}
                />
                {((this.state.getOrganizers === true) ? GetOrganizersList(this.props.PnkStore, this.HandleGetOrganizersListSuccessResponse) : "")}
                {((this.state.getCategory === true) ? GetCategoryData(this.props.PnkStore, this.HandleGetCategoryListSuccessResponse) : "")}
                {((this.state.getupcomingEvents === true) ? AllUpcomingEvents(this.props.PnkStore, this.HandleAllUpcomingEventsListSuccessResponse) : "")}
                {((this.state.getFilterEvent === true) ? FilterEvent(this.props.PnkStore, this.filter, this.HandleAllUpcomingEventsListSuccessResponse) : "")}
            </div>
        )
    }
}

export const UpcomingEvents = PnkConnect(upcomingEvents, '');